module.exports = __webpack_public_path__ + "static/img/10.69916c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/10.png
// module id = tR2K
// module chunks = 0